import React, { useCallback, useMemo } from "react";
import SearchBar from "../../Elements/Search/SearchBar";
import { Tables } from "../../Elements/Tables/Tables";
import { ReactComponent as EyeIcon } from "../../../assets/svgs/eye-icon.svg";
import { useLocation, useNavigate } from "react-router-dom";

const AssignedForm = ({ formAllotmentData, handlePageChange, setSearch, pageSize, setSkip, total, pageNo, setPageNo }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const parentState = location.state;

  const handleViewAction = useCallback(
    (item) => {
      const formId = item?.template?._id;
      if (!formId) {
        return;
      }
      navigate(`/setting/users/user-details/form-details/${formId}`, {
        state: {
          ...(parentState || {}),
          title: item?.template?.title || "Form Details",
          projectName: item?.project?.name || "N/A",
          from: location.pathname,
          allotmentId: item?._id,
          parentState,
        },
      });
    },

    [location.pathname, navigate, parentState]
  );



  
  const tableData = useMemo(() => {
    return (formAllotmentData || []).map((item, index) => ({
      key: item._id,
      serial: (pageNo - 1) * pageSize + index + 1,
      title: item?.template?.title || "N/A",
      status: item?.user?.[0]?.status || "N/A",
      projectName: item?.project?.name || "N/A",
      assignedOn: item?.createdAt
        ? new Date(item.createdAt).toLocaleDateString()
        : "N/A",
      action: (
        <div className="flex gap-3">
          <EyeIcon
            style={{ fontSize: "18px", cursor: "pointer" }}
            onClick={() => handleViewAction(item)}
          />
        </div>
      ),
    }));
  }, [formAllotmentData, pageNo, pageSize, handleViewAction]);

  const header = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Form Title", key: "title" },
      { label: "Assigned On", key: "assignedOn" },
      { label: "Status", key: "status" },
      { label: "Project", key: "projectName" },
      { label: "Action", key: "action" },
    ],
    []
  );

  return (
    <div>
      <div className="flex gap-16 px-16 pb-5">
        <p className="text-[#06513D] pt-2 text-xl">Assigned Form</p>
        <SearchBar
          width="300px"
          onSearch={(value) => {
            setSearch(value);
            setPageNo(1);
            setSkip(0);
          }}
        />
      </div>

      <Tables
        data={tableData}
        headers={header}
        pageSize={pageSize}
        current={pageNo}
        total={total}
        onChange={handlePageChange}
      />
    </div>
  );
};

export default AssignedForm;
